<template>
    <header class="container-fluid shadow-sm py-2 px-3 px-md-4 px-lg-5">
        <b-row class="align-items-center">
            <b-col id="logo-container" class="d-flex">
                <b-link href="https://www.assistel.paris/">
                    <img :src="logo.source" :alt="logo.alt" />
                </b-link>
            </b-col>

            <b-col cols="auto" class="d-flex">
                <div class="d-none d-xl-flex align-items-center">
                    <b-button to="/" class="btn-secondary mr-3" size="md" v-b-modal.help-modal>
                        Création & Domiciliation
                    </b-button>

                    <b-link href="https://www.assistel.paris/permanence-telephone-medical-paris" class="mr-3">Permanence téléphonique médicale</b-link>

                    <b-link href="https://www.assistel.paris/secretariat-externalise-paris" class="mr-3">Standard externalisé</b-link>

                    <b-link href="https://www.assistel.paris/contact" class="mr-3">Contact</b-link>

                    <b-link href="https://www.assistel.paris/blog" class="mr-3">Blog</b-link>

                    <b-link :href="'tel:' + phone.num">
                        <b-button class="btn-dark d-flex" size="md" v-b-modal.contact-modal>
                            <img :src="phone.classic" alt="Téléphone" width="20" height="auto" class="mr-2">
                            {{ phone.num }}
                        </b-button>
                    </b-link>
                </div>

                <b-button
                v-b-toggle.sidebar
                variant="link"
                class="hamburger hamburger--elastic d-flex d-xl-none"
                @click="burgerSwitch">
                    <span class="hamburger-box">
                      <span class="hamburger-inner"></span>
                    </span>
                </b-button>
            </b-col>
        </b-row>
    </header>
</template>

<script>
    export default {
        name: 'Header',
        data() {
            return {
                logo: {
                    source: require("@/assets/images/assistel.png"),
                    alt: "Logo de Assistel"
                },
                phone: {
                    classic: require("@/assets/images/icons/phone/phone.svg"),
                    filled: require("@/assets/images/icons/phone/phone-filled.svg"),
                    num: "01 39 23 65 65"
                },
                burgerIsActive: false
            }
        },
        methods: {
            burgerSwitch() {
                let hamburger = document.querySelector(".hamburger");

                hamburger.classList.toggle("is-active");
            }
        }
    }
</script>
